import React from 'react'

export const Check = () => (
  <svg
    version="1.1"
    height="100%"
    viewBox="-3 -3 50 50"
  >
    <g>
      <path
        d="M14.5787309,21.7236028 C13.9864865,21.1305497 13.0364277,21.1305497 12.4441833,21.7112476 C11.8519389,22.3043007 11.8519389,23.2556568 12.4441833,23.84871 L17.7497062,29.1861883 C18.0458284,29.4827149 18.4283196,29.6309782 18.8231492,29.6309782 C19.2056404,29.6309782 19.5881316,29.4827149 19.8842538,29.1861883 L32.5558167,16.5838089 C33.1480611,15.9907557 33.1480611,15.0393996 32.5558167,14.4463465 C31.9635723,13.8532933 31.0135135,13.8532933 30.4212691,14.4339912 L18.8231492,25.9861724 L14.5787309,21.7236028 Z"
        fill="#fff"
      />
    </g>
  </svg>
)

export const Exclamation = () => (
  <svg
    version="1.1"
    height="30px"
    width="30px"
    viewBox="0 0 489 489"
  >
    <g>
      <path
        d="M244.709,389.496c18.736,0,34.332-14.355,35.91-33.026l24.359-290.927c1.418-16.873-4.303-33.553-15.756-46.011   C277.783,7.09,261.629,0,244.709,0s-33.074,7.09-44.514,19.532C188.74,31.99,183.022,48.67,184.44,65.543l24.359,290.927   C210.377,375.141,225.973,389.496,244.709,389.496z"
      />
      <path
        d="M244.709,410.908c-21.684,0-39.256,17.571-39.256,39.256c0,21.683,17.572,39.254,39.256,39.254   s39.256-17.571,39.256-39.254C283.965,428.479,266.393,410.908,244.709,410.908z"
      />
    </g>
  </svg>
)



// WEBPACK FOOTER //
// ./src/modules/icons/checkCircleIcons.jsx